import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-screen-content',
  templateUrl: './screen-content.component.html',
  styleUrls: ['./screen-content.component.scss']
})
export class ScreenContentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
